export default __webpack_public_path__ + "2caf7d1765d03b8a705863ab0d2176d6.png";